const updateForm = document.querySelector('form#updateMember')

const getCookie = cookieName => {
  const value = '; ' + document.cookie
  const parts = value.split('; ' + cookieName + '=')
  return parts.length === 2 ? parts.pop().split(';').shift() : false
}

const unsetCookie = cookieName => {
  document.cookie = cookieName + '=false; expires=Thu, 01 Jan 1970 00:00:01 GMT; Max-Age=0; path=/; SameSite=lax; Secure'
}

if (updateForm) {
  const formId = updateForm.id
  const cookieName = 'update_member_memorized'
  const submitButton = updateForm.querySelector('.submit button[type="submit"]')

  const itemRadioAdressePrivat = document.getElementById(`${formId}-ctrl_setpostaladdress-0`)
  const itemRadioAdressePraxis = document.getElementById(`${formId}-ctrl_setpostaladdress-1`)
  const itemHiddenAdressePrivatSuffix = document.getElementById(`${formId}-adpostaladdresses_0_suffix`)
  const itemHiddenAdressePraxisSuffix = document.getElementById(`${formId}-adpostaladdresses_1_suffix`)

  if (!getCookie(cookieName)) {
    document.cookie = `${cookieName}=true; path=/; SameSite=lax; Secure`

    const formId = updateForm.id
    const targetInputs = {}
    const hiddenInputsQuery = updateForm.querySelectorAll(`input[id^="${formId}-hidden-"]`)

    hiddenInputsQuery.forEach(hiddenInput => {
      const inputId = hiddenInput.id.replace(`${formId}-hidden-`, '')
      targetInputs[inputId] = hiddenInput
    })

    const textInputs = updateForm.querySelectorAll('input[type="text"]')

    textInputs.forEach(input => {
      const inputId = input.id.replace(`${formId}-`, '')

      if (targetInputs[inputId]) {
        targetInputs[inputId].value = input.value
      }
    })

    const radios = updateForm.querySelectorAll('input[type="radio"]')
    const groupRegMatch = /-\d+$/

    radios.forEach(radio => {
      if (radio.checked) {
        const radioLabel = radio.nextElementSibling.textContent
        const radioId1 = radio.id.replace(`${formId}-`, '')
        const radioId2 = radioId1.replace(groupRegMatch, '')

        if (targetInputs[radioId2]) {
          targetInputs[radioId2].value = radioLabel
        }
      }
    })
  }

  const changeRadioAdresstyp = (type) => {
    if (type === 'Privat') {
      itemHiddenAdressePrivatSuffix.value = 'Privat (Post)'
      itemHiddenAdressePraxisSuffix.value = 'Praxis'
    } else {
      itemHiddenAdressePrivatSuffix.value = 'Privat'
      itemHiddenAdressePraxisSuffix.value = 'Praxis (Post)'
    }
  }

  if (itemRadioAdressePrivat) {
    if (itemHiddenAdressePrivatSuffix.value.includes('(Post)')) {
      itemRadioAdressePrivat.checked = true
    } else {
      itemRadioAdressePraxis.checked = true
    }

    itemRadioAdressePrivat.addEventListener('change', (e) => changeRadioAdresstyp(e.target.value))
    itemRadioAdressePraxis.addEventListener('change', (e) => changeRadioAdresstyp(e.target.value))
  }

  if (submitButton) {
    submitButton.addEventListener('click', e => {
      // e.preventDefault()
      unsetCookie(cookieName)
      // updateForm.submit()
    })
  }
}
